exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n.serachTags .autocomplete-content{\n    position: absolute;\n}\n/*.main-container {\n    -webkit-animation-duration: 500ms;\n            animation-duration: 500ms;\n     -webkit-animation-delay: 1s;\n            animation-delay: 1s; \n  }  */\n\n  @media (max-width: 520px){\n    .modal-footer-two-lines {\n      position: fixed;\n      top: 80%;\n    }\n  }\n\n  @media (min-width: 520px){\n    .dividing-line-hidden{\n      display: none;\n    }\n  }\n  \n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/clearance-item/clearance-item.component.css
// module id = 466
// module chunks = 1